import { render, staticRenderFns } from "./TaskRow.vue?vue&type=template&id=4531e1a6"
import script from "./TaskRow.vue?vue&type=script&lang=js"
export * from "./TaskRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports